import * as Types from '../../graphql/types';

import { CalendarMonthString, CalendarDateTimeString, CalendarDateString } from "scalars";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PayrollItemFragment = { __typename?: 'Payroll', id: string, withdrawalDate: CalendarDateString, checkDate: CalendarDateString, providerName: string, netPay: string, employerTaxes: string, employeeTaxes: string, benefits: string, employeeBenefitsDeductions: string, payPeriod?: { __typename?: 'PayPeriod', from: CalendarDateString, to: CalendarDateString } | null, benefitDetails: Array<{ __typename?: 'BenefitDetail', id: string, name: string, employeePortion: string, employerPortion: string }>, journalMapping: { __typename?: 'PayrollJournalMap', items: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, memoLines: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, summaryItems: Array<{ __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null }>, relatedTransactions: Array<{ __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string }> }, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }> };

export type PayrollProviderFragment = { __typename?: 'PayrollProvider', institutionId: string, institutionName: string, accountId: string };

export type PagedPayrollItemFragment = { __typename?: 'Payroll', id: string, checkDate: CalendarDateString, benefits: string, employeeBenefitsDeductions: string, employeeTaxes: string, employerTaxes: string, netPay: string };

export type PayrollSummaryItemFragment = { __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null };

export type PayrollSummaryItemSplitFragment = { __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string };

export type PayrollLinkedTransactionFragment = { __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string };

export type PayrollJournalMapItemFragment = { __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null };

export type PayrollEntryFragment = { __typename?: 'LedgerEntry', amount?: string | null, account: { __typename?: 'LedgerAccount', displayId: string, displayName: string } };

export type CompanyBenefitFragment = { __typename?: 'CompanyBenefit', id: string, name: string, description: string };

export type PayrollQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PayrollQuery = { __typename?: 'Query', payroll: { __typename?: 'Payroll', id: string, withdrawalDate: CalendarDateString, checkDate: CalendarDateString, providerName: string, netPay: string, employerTaxes: string, employeeTaxes: string, benefits: string, employeeBenefitsDeductions: string, payPeriod?: { __typename?: 'PayPeriod', from: CalendarDateString, to: CalendarDateString } | null, benefitDetails: Array<{ __typename?: 'BenefitDetail', id: string, name: string, employeePortion: string, employerPortion: string }>, journalMapping: { __typename?: 'PayrollJournalMap', items: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, memoLines: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, summaryItems: Array<{ __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null }>, relatedTransactions: Array<{ __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string }> }, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }> } };

export type PayrollsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  page?: Types.InputMaybe<Types.PageInput>;
  sortBy?: Types.InputMaybe<Types.PayrollSortOrder>;
  filterBy?: Types.InputMaybe<Types.PayrollFilterBy>;
}>;


export type PayrollsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }>, payrollProviders: Array<{ __typename?: 'PayrollProvider', institutionId: string, institutionName: string, accountId: string }>, payrolls?: { __typename?: 'PayrollPaginator', nodes: Array<{ __typename?: 'Payroll', id: string, withdrawalDate: CalendarDateString, checkDate: CalendarDateString, providerName: string, netPay: string, employerTaxes: string, employeeTaxes: string, benefits: string, employeeBenefitsDeductions: string, payPeriod?: { __typename?: 'PayPeriod', from: CalendarDateString, to: CalendarDateString } | null, benefitDetails: Array<{ __typename?: 'BenefitDetail', id: string, name: string, employeePortion: string, employerPortion: string }>, journalMapping: { __typename?: 'PayrollJournalMap', items: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, memoLines: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, summaryItems: Array<{ __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null }>, relatedTransactions: Array<{ __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string }> }, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }> }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, total?: number | null } } | null } | null };

export type CreatePayrollMutationVariables = Types.Exact<{
  input: Types.CreatePayrollInput;
}>;


export type CreatePayrollMutation = { __typename?: 'Mutation', createPayroll: { __typename?: 'Payroll', id: string, withdrawalDate: CalendarDateString, checkDate: CalendarDateString, providerName: string, netPay: string, employerTaxes: string, employeeTaxes: string, benefits: string, employeeBenefitsDeductions: string, payPeriod?: { __typename?: 'PayPeriod', from: CalendarDateString, to: CalendarDateString } | null, benefitDetails: Array<{ __typename?: 'BenefitDetail', id: string, name: string, employeePortion: string, employerPortion: string }>, journalMapping: { __typename?: 'PayrollJournalMap', items: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, memoLines: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, summaryItems: Array<{ __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null }>, relatedTransactions: Array<{ __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string }> }, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }> } };

export type UpdatePayrollMutationVariables = Types.Exact<{
  input: Types.UpdatePayrollInput;
}>;


export type UpdatePayrollMutation = { __typename?: 'Mutation', updatePayroll: { __typename?: 'Payroll', id: string, withdrawalDate: CalendarDateString, checkDate: CalendarDateString, providerName: string, netPay: string, employerTaxes: string, employeeTaxes: string, benefits: string, employeeBenefitsDeductions: string, payPeriod?: { __typename?: 'PayPeriod', from: CalendarDateString, to: CalendarDateString } | null, benefitDetails: Array<{ __typename?: 'BenefitDetail', id: string, name: string, employeePortion: string, employerPortion: string }>, journalMapping: { __typename?: 'PayrollJournalMap', items: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, memoLines: Array<{ __typename?: 'PayrollJournalMapItem', category?: Types.PayrollJournalMapItemCategory | null, groupId?: number | null, itemName?: string | null, amount?: string | null, journalName?: string | null, journalDebit?: string | null, journalCredit?: string | null, hasMemoLine?: boolean | null }>, summaryItems: Array<{ __typename?: 'PayrollSummaryItem', itemName: string, amount?: string | null, itemSplits?: Array<{ __typename?: 'PayrollSummaryItemSplit', id: string, name: string, amount: string }> | null }>, relatedTransactions: Array<{ __typename?: 'PayrollLinkedTransaction', date: CalendarDateTimeString, description: string, amount: string }> }, companyBenefits: Array<{ __typename?: 'CompanyBenefit', id: string, name: string, description: string }> } };

export type DeletePayrollMutationVariables = Types.Exact<{
  input: Types.DeletePayrollInput;
}>;


export type DeletePayrollMutation = { __typename?: 'Mutation', deletePayroll: { __typename?: 'DeletePayrollResult', success: boolean } };

export const PayrollJournalMapItemFragmentDoc = gql`
    fragment payrollJournalMapItem on PayrollJournalMapItem {
  category
  groupId
  itemName
  amount
  journalName
  journalDebit
  journalCredit
  hasMemoLine
}
    `;
export const PayrollSummaryItemSplitFragmentDoc = gql`
    fragment payrollSummaryItemSplit on PayrollSummaryItemSplit {
  id
  name
  amount
}
    `;
export const PayrollSummaryItemFragmentDoc = gql`
    fragment payrollSummaryItem on PayrollSummaryItem {
  itemName
  amount
  itemSplits {
    ...payrollSummaryItemSplit
  }
}
    ${PayrollSummaryItemSplitFragmentDoc}`;
export const PayrollLinkedTransactionFragmentDoc = gql`
    fragment payrollLinkedTransaction on PayrollLinkedTransaction {
  date
  description
  amount
}
    `;
export const CompanyBenefitFragmentDoc = gql`
    fragment companyBenefit on CompanyBenefit {
  id
  name
  description
}
    `;
export const PayrollItemFragmentDoc = gql`
    fragment payrollItem on Payroll {
  id
  payPeriod {
    from
    to
  }
  withdrawalDate
  checkDate
  providerName
  netPay
  employerTaxes
  employeeTaxes
  benefits
  employeeBenefitsDeductions
  benefitDetails {
    id
    name
    employeePortion
    employerPortion
  }
  journalMapping {
    items {
      ...payrollJournalMapItem
    }
    memoLines {
      ...payrollJournalMapItem
    }
    summaryItems {
      ...payrollSummaryItem
    }
    relatedTransactions {
      ...payrollLinkedTransaction
    }
  }
  companyBenefits {
    ...companyBenefit
  }
}
    ${PayrollJournalMapItemFragmentDoc}
${PayrollSummaryItemFragmentDoc}
${PayrollLinkedTransactionFragmentDoc}
${CompanyBenefitFragmentDoc}`;
export const PayrollProviderFragmentDoc = gql`
    fragment payrollProvider on PayrollProvider {
  institutionId
  institutionName
  accountId
}
    `;
export const PagedPayrollItemFragmentDoc = gql`
    fragment pagedPayrollItem on Payroll {
  id
  checkDate
  benefits
  employeeBenefitsDeductions
  employeeTaxes
  employerTaxes
  netPay
}
    `;
export const PayrollEntryFragmentDoc = gql`
    fragment payrollEntry on LedgerEntry {
  account {
    displayId
    displayName
  }
  amount
}
    `;
export const PayrollDocument = gql`
    query payroll($id: ID!) {
  payroll(id: $id) {
    ...payrollItem
  }
}
    ${PayrollItemFragmentDoc}`;

/**
 * __usePayrollQuery__
 *
 * To run a query within a React component, call `usePayrollQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayrollQuery(baseOptions: Apollo.QueryHookOptions<PayrollQuery, PayrollQueryVariables> & ({ variables: PayrollQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollQuery, PayrollQueryVariables>(PayrollDocument, options);
      }
export function usePayrollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollQuery, PayrollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollQuery, PayrollQueryVariables>(PayrollDocument, options);
        }
export function usePayrollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollQuery, PayrollQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollQuery, PayrollQueryVariables>(PayrollDocument, options);
        }
export type PayrollQueryHookResult = ReturnType<typeof usePayrollQuery>;
export type PayrollLazyQueryHookResult = ReturnType<typeof usePayrollLazyQuery>;
export type PayrollSuspenseQueryHookResult = ReturnType<typeof usePayrollSuspenseQuery>;
export type PayrollQueryResult = Apollo.QueryResult<PayrollQuery, PayrollQueryVariables>;
export const PayrollsDocument = gql`
    query payrolls($companyId: ID!, $page: PageInput, $sortBy: PayrollSortOrder, $filterBy: PayrollFilterBy) {
  company(id: $companyId) {
    id
    companyBenefits {
      ...companyBenefit
    }
    payrollProviders {
      ...payrollProvider
    }
    payrolls(page: $page, sortBy: $sortBy, filterBy: $filterBy) {
      nodes {
        ...payrollItem
      }
      pageInfo {
        endCursor
        hasNextPage
        total
      }
    }
  }
}
    ${CompanyBenefitFragmentDoc}
${PayrollProviderFragmentDoc}
${PayrollItemFragmentDoc}`;

/**
 * __usePayrollsQuery__
 *
 * To run a query within a React component, call `usePayrollsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function usePayrollsQuery(baseOptions: Apollo.QueryHookOptions<PayrollsQuery, PayrollsQueryVariables> & ({ variables: PayrollsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayrollsQuery, PayrollsQueryVariables>(PayrollsDocument, options);
      }
export function usePayrollsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayrollsQuery, PayrollsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayrollsQuery, PayrollsQueryVariables>(PayrollsDocument, options);
        }
export function usePayrollsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayrollsQuery, PayrollsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayrollsQuery, PayrollsQueryVariables>(PayrollsDocument, options);
        }
export type PayrollsQueryHookResult = ReturnType<typeof usePayrollsQuery>;
export type PayrollsLazyQueryHookResult = ReturnType<typeof usePayrollsLazyQuery>;
export type PayrollsSuspenseQueryHookResult = ReturnType<typeof usePayrollsSuspenseQuery>;
export type PayrollsQueryResult = Apollo.QueryResult<PayrollsQuery, PayrollsQueryVariables>;
export const CreatePayrollDocument = gql`
    mutation createPayroll($input: CreatePayrollInput!) {
  createPayroll(input: $input) {
    ...payrollItem
  }
}
    ${PayrollItemFragmentDoc}`;
export type CreatePayrollMutationFn = Apollo.MutationFunction<CreatePayrollMutation, CreatePayrollMutationVariables>;

/**
 * __useCreatePayrollMutation__
 *
 * To run a mutation, you first call `useCreatePayrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayrollMutation, { data, loading, error }] = useCreatePayrollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayrollMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayrollMutation, CreatePayrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayrollMutation, CreatePayrollMutationVariables>(CreatePayrollDocument, options);
      }
export type CreatePayrollMutationHookResult = ReturnType<typeof useCreatePayrollMutation>;
export type CreatePayrollMutationResult = Apollo.MutationResult<CreatePayrollMutation>;
export type CreatePayrollMutationOptions = Apollo.BaseMutationOptions<CreatePayrollMutation, CreatePayrollMutationVariables>;
export const UpdatePayrollDocument = gql`
    mutation updatePayroll($input: UpdatePayrollInput!) {
  updatePayroll(input: $input) {
    ...payrollItem
  }
}
    ${PayrollItemFragmentDoc}`;
export type UpdatePayrollMutationFn = Apollo.MutationFunction<UpdatePayrollMutation, UpdatePayrollMutationVariables>;

/**
 * __useUpdatePayrollMutation__
 *
 * To run a mutation, you first call `useUpdatePayrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePayrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePayrollMutation, { data, loading, error }] = useUpdatePayrollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePayrollMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePayrollMutation, UpdatePayrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePayrollMutation, UpdatePayrollMutationVariables>(UpdatePayrollDocument, options);
      }
export type UpdatePayrollMutationHookResult = ReturnType<typeof useUpdatePayrollMutation>;
export type UpdatePayrollMutationResult = Apollo.MutationResult<UpdatePayrollMutation>;
export type UpdatePayrollMutationOptions = Apollo.BaseMutationOptions<UpdatePayrollMutation, UpdatePayrollMutationVariables>;
export const DeletePayrollDocument = gql`
    mutation deletePayroll($input: DeletePayrollInput!) {
  deletePayroll(input: $input) {
    success
  }
}
    `;
export type DeletePayrollMutationFn = Apollo.MutationFunction<DeletePayrollMutation, DeletePayrollMutationVariables>;

/**
 * __useDeletePayrollMutation__
 *
 * To run a mutation, you first call `useDeletePayrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePayrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePayrollMutation, { data, loading, error }] = useDeletePayrollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePayrollMutation(baseOptions?: Apollo.MutationHookOptions<DeletePayrollMutation, DeletePayrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePayrollMutation, DeletePayrollMutationVariables>(DeletePayrollDocument, options);
      }
export type DeletePayrollMutationHookResult = ReturnType<typeof useDeletePayrollMutation>;
export type DeletePayrollMutationResult = Apollo.MutationResult<DeletePayrollMutation>;
export type DeletePayrollMutationOptions = Apollo.BaseMutationOptions<DeletePayrollMutation, DeletePayrollMutationVariables>;